
/**
 * An ui interface which has to be implemented by all display and editor templates.
 */
$.widget('ag.agField',
{
    options: {

        // a function getting value of object
        getValue: null,

        // a function setting value to object
        setValue: null,

        // function for setting element data
        setElementData: null
    },

    _create: function() { },

    value: function (value) {
        if ($.isFunction(this.options.setValue) && arguments.length >= 1)
            return this.options.setValue(value);

        if ($.isFunction(this.options.getValue))
            return this.options.getValue();

        throw 'Value getter or setter not implemented on field.';
    },

    setElementData: function (value) {
        if ($.isFunction(this.options.setElementData))
            return this.options.setElementData(value);
    }
});

(function ($) {

    /**
     * Helper method which finds all field(s) by basename (dynamic forms), input id, or name
     * inside of the provided jquery collection.
     * 
     * Method can be used only inside or on forms.
     * 
     * @param {basename of form field, or id of html input, or name of html input} name 
     * @returns {field(s)} 
     */
    $.fn.field = function (name) {

        return this
            .closest('form')
            .find(
                'div.ag-field[data-basename="' + name + '"],' +
                'div.ag-field[data-name="' + name + '"],' +
                'div.ag-field[data-id="' + name + '"]');
    };

    /**
     * Helper method which finds all field(s) by basename (dynamic forms), input id, or name
     * inside of the provided jquery collection.
     * 
     * Method can be used only inside or on forms.
     * 
     * @param {basename of form field, or id of html input, or name of html input} name 
     * @returns {field(s)} 
     */
    $.fn.formField = function (name) {
        return this
            .closest('form')
            .find(
                'div.ag-form-field[data-basename="' + name + '"],' +
                'div.ag-form-field[data-name="' + name + '"],' +
                'div.ag-form-field[data-id="' + name + '"]');
    };

    /**
     * Helper method which finds all cells(s) by basename (dynamic forms), input id, or name
     * inside of the provided jquery collection.
     * 
     * Method can be used only inside or on table fors (tr).
     * 
     * @param {basename of form field, or id of html input, or name of html input} name 
     * @returns {field(s)} 
     */
    $.fn.tableCell = function (name) {
        return this
            .closest('tr')
            .find(
                'div.ag-table-cell[data-basename="' + name + '"],' +
                'div.ag-table-cell[data-name="' + name + '"],' +
                'div.ag-table-cell[data-id="' + name + '"]');
    };

    /**
     * Helper method which finds all field(s) by form element id (dynamic forms)
     * inside of the provided jquery collection.
     * 
     * Method can be used only inside or on forms.
     * 
     * @param {element id of form field} name 
     * @returns {field(s)} 
     */
    $.fn.formElement = function (key) {
        return this
            .closest('form')
            .find(
            'div.ag-form-field[data-form-element-id="' + key + '"],' +
            'div.ag-form-field[data-basename="' + key + '"],' +
            'div.ag-form-table[data-form-element-id="' + key + '"],' +
            'div.ag-form-table[data-basename="' + key + '"],' +
            'div.ag-form-element[data-form-element-id="' + key + '"],' +
            'div.ag-form-element[data-basename="' + key + '"]');
    };

    /**
     * Helper method which finds all field(s) by form element id (dynamic forms)
     * inside of the provided jquery collection.
     * 
     * Method can be used only inside or on forms.
     * 
     * @param {element id of form field} name 
     * @returns {field(s)} 
     */
    $.fn.formElement2 = function (key) {
        return this
            .closest('form')
            .find('div.grid-container-dynamic-form[data-basename="' + key + '"]');
    };

    /**
     * Helper method which finds all table(s) by table base name (dynamic forms)
     * inside of the provided jquery collection.
     * 
     * Method can be used only inside or on forms.
     * 
     * @param {table base name} name 
     * @returns {table(s)} 
     */
    $.fn.formTable = function (baseName) {
        return this
            .closest('form')
            .find(
            'div.ag-form-table[data-basename="' + baseName + '"]');
    };

    /**
     * Helper method which finds a control by basename (dynamic forms), input id, or name
     * inside of the provided jquery collection.
     * 
     * Method can be used only inside or on forms.
     * 
     * @param {basename of form field, or id of html input, or name of html input} name 
     * @returns {field(s)} 
     */
    $.fn.control = function (name) {

        if (name) {

            if (name.startsWith('DynamicData.'))
                name = name.replace('DynamicData.', '');

            var controls = this.closest('form').data('agControls');

            if (controls)
                return controls[name];

            return undefined;
        }
        else {
            return this.data('agControl');
        }
    };

}(jQuery));
